module.exports = __webpack_public_path__ + "img/tourist.dbf1d242.png";